<div class="claim-attachments-header">
  <div class="claim-attachments-title claim-number">Claim <span
  data-cy="claim-attachments-claim-number">{{claim.number}}</span></div>

  <div class="claim-attachments-title">
    <app-tooltip [dynamic]="false" [disable]="disableReferenceNumberTooltip()"
      message="The reference number is registered only after the Claim submission"
      class="display-inline-flex">
      @if (true) {
        <span class="claim-attachments-reference-number-label"
        data-cy="claim-attachments-reference-number-label">Ref. No.</span>
      }
      <span [ngClass]="getCssClass()"
      data-cy="claim-attachments-reference-number">{{getReferenceNumberLabel()}}</span>
    </app-tooltip>
  </div>
</div>

@if (fileManagerIsOffline) {
  <div>
    <app-attachments-list-display-error
    [refreshAttachments]="refreshAttachments"></app-attachments-list-display-error>
  </div>
} @else {
  <app-attachments-list-display [directory]="$safeNavigationMigration(claim?.attachmentDirectory)"
  [attachments]="files"></app-attachments-list-display>
}

